module.exports = __webpack_public_path__ + "static/animation-award-fb609fc4d98c5e6b06cac15558db9628.png";